import adminApi from '@/api/administration';
import {mutationTypes} from '@/store/modules/administration/mutations';

export const actionsTypes = {
  getCompanyList: '[administration] get companies',
  getUserList: '[administration] get users',

  toggleUserBan: '[administration] toggle user ban',
  toggleUserImp: '[administration] toggle user impersonate',
  toggleUserAdmin: '[administration] toggle user admin',
  toggleUserPlatformAdmin: '[administration] toggle user platform admin',

  changeUserEmail: '[administration] change user email',
  changeUserName: '[administration] change user name',
};

const actions = {
  [actionsTypes.getCompanyList](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .getCompanyList()
        .then((response) => {
          context.commit(mutationTypes.getCompanyListSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },
  [actionsTypes.getUserList](
    context,
    {search = undefined, company_ids, limit = 50, offset = 0, reload = false}
  ) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .getUserList(search, company_ids, limit, offset + context.state.offset)
        .then((response) => {
          context.commit(mutationTypes.getUserListSuccess, {...response.data, reload});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },

  [actionsTypes.toggleUserBan](context, {uid, banned}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .toggleUserBanState(uid, banned)
        .then((response) => {
          context.commit(mutationTypes.updateUserInList, {type: 'ban', uid, banned});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },
  [actionsTypes.toggleUserImp](context, {uid, action}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .toggleUserImp(uid, action)
        .then((response) => {
          context.commit(mutationTypes.updateUserInList, {type: 'imp', uid, action});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },
  [actionsTypes.toggleUserAdmin](context, {uid, action}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .toggleUserAdmin(uid, action)
        .then((response) => {
          context.commit(mutationTypes.updateUserInList, {type: 'admin', uid, action});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },
  [actionsTypes.toggleUserPlatformAdmin](context, {uid, action}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .toggleUserPlatformAdmin(uid, action)
        .then((response) => {
          context.commit(mutationTypes.updateUserInList, {
            type: 'platform_admin',
            uid,
            action,
          });
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },

  [actionsTypes.changeUserEmail](context, {uid, new_email}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.startLoading);
      adminApi
        .changeUserEmail(uid, new_email)
        .then((response) => {
          context.commit(mutationTypes.updateUserInList, {type: 'email', uid, new_email});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.stopLoading);
          reject(result);
        });
    });
  },
  [actionsTypes.changeUserName](context, {uid, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.changeUserNameStart);
      adminApi
        .changeUserName(uid, data)
        .then((response) => {
          context.commit(mutationTypes.changeUserNameSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.changeUserNameFailure, result?.response?.data?.message);
          reject(result);
        });
    });
  },
};

export default actions;
